function dateConvert(dateString: string): string{
    const dateObj = new Date(dateString);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString();
    return `${date} ${time}`
  }

  export default dateConvert;